<script>
import moment from "moment";
import InputRut from "../InputRut.vue";
import InputRegion from "../InputRegion.vue";
import FormGroupSelect from "../FormGroupSelect.vue";
export default {
  components: { InputRut, InputRegion, FormGroupSelect },
  name: "FormUsuario",

  props: {
    despacho: Object,
    postInformacionGeneral: Function,
    informacionGeneral: Object,
    editar: Function,
    estados: Object,
  },
  data() {
    return {
      //importacion
      transporte: "",
      correo_transporte: "",

      fecha_aforo_dus_legalizado: "",
      aforo_dus_legalizado: "",
      fecha_aforo_zona_primaria: "",
      aforo_zona_primaria: "",
      estado_salida: "",
      fecha_salida_programada: "",
      numero_reserva: "",
      puerto_aereo: "",
      fecha_ingreso_zona_primaria: "",
      estado: "",
      aforo: "",
      pantalla: false,
    };
  },
  mounted() {
    if (screen.width <= 660) this.pantalla = false;
    else this.pantalla = true;
  },
  methods: {
    cambiarRut(value) {
      this.cliente_rut = value;
    },
    cambiarRutTransporte(value) {
      this.transporte = value;
    },
  },
};
</script>

<template>
  <div>
    <div class="grid grid-cols-1 gap-4">
      <!--ESTADO PRESENTACION MATRIZ -->
      <div
        v-if="despacho.tipo.puerto_aereo && estados.puerto_aereo"
        class="grid grid-cols-4"
      >
        <div class="text-left">Puerto/Aereo</div>
        <div class="col-span-2 text-right font-bold">
          {{
            despacho?.tipo?.puerto_aereo
              ? despacho?.tipo?.extraportuario?.nombre
              : "-"
          }}
        </div>

        <div class="ml-auto">
          <button
            @click="editar('aduanero_exportacion', 'puerto_aereo')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </div>
      </div>
      <div v-else class="flex flex-col gap-4 sm:w-1/2">
        <div>
          <label for="importancia-select">Puerto/Aereo</label>
          <select id="importancia-select" v-model="puerto_aereo" required>
            <option value="0" disabled>Selecciona el Puerto / Aereo</option>
            <option
              :key="index"
              v-for="(
                extraportuario, index
              ) in informacionGeneral.extraportuarios"
              :value="extraportuario.id"
            >
              {{ extraportuario.nombre }}
            </option>
          </select>
        </div>
        <div class="flex flex-row gap-4 ml-auto">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('aduanero_exportacion', 'puerto_aereo', true, {
                puerto_aereo: puerto_aereo,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('aduanero_exportacion', 'puerto_aereo')"
          >
            Cancelar
          </button>
        </div>
      </div>
      <!--NUMERO RESERVA -->
      <div v-if="despacho.tipo.numero_reserva && estados.numero_reserva">
        <div class="text-left">
          <p>Número Reserva</p>
        </div>
        <div class="text-right">
          {{ despacho?.tipo?.numero_reserva ?? "-" }}
        </div>
        <div class="text-right">
          <button
            v-if="pantalla == true"
            @click="editar('aduanero_exportacion', 'numero_reserva')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('aduanero_exportacion', 'numero_reserva')"
            class="btn-principal"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else>
        <div class="text-right">
          <form class="form-input">
            <div>
              <div>
                <b-form-group
                  class="text-left"
                  label="Número Reserva"
                  label-for="numero_reserva-select"
                >
                  <input type="text" v-model="numero_reserva" required />
                </b-form-group>
              </div>
              <div>
                <button
                  class="btn-principal"
                  type="button"
                  @click="
                    editar('aduanero_exportacion', 'numero_reserva', true, {
                      numero_reserva: numero_reserva,
                    })
                  "
                >
                  Guardar
                </button>
                <button
                  class="btn-secundario"
                  type="button"
                  @click="editar('aduanero_exportacion', 'numero_reserva')"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!--Transporte -->
      <div v-if="despacho.transporte && estados.transporte" hidden>
        <div class="text-left">
          <p>Transporte</p>
        </div>
        <div class="text-right">
          <p v-if="despacho.transporte">
            {{ despacho.transporte }} - {{ despacho.correo_transporte }}
          </p>
          <p v-else>-</p>
        </div>
        <div class="text-right" hidden>
          <button
            v-if="pantalla == true"
            @click="editar('aduanero_exportacion', 'transporte')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('aduanero_exportacion', 'transporte')"
            class="btn-principal"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else hidden>
        <div class="text-right">
          <form class="form-input">
            <div>
              <div>
                <b-form-group
                  class="text-left"
                  label="Nombre de Transporte Local (Chile)"
                  label-for="transporte-select"
                >
                  <input type="text" v-model="transporte" required />
                </b-form-group>
              </div>
              <div>
                <b-form-group
                  class="text-left"
                  label="Correo de Transporte Local"
                  label-for="correo_transporte-select"
                >
                  <input type="email" v-model="correo_transporte" required />
                </b-form-group>
              </div>

              <div>
                <button
                  class="btn-principal"
                  type="button"
                  @click="
                    editar('aduanero_exportacion', 'transporte', true, {
                      transporte: transporte,
                      correo_transporte: correo_transporte,
                    })
                  "
                >
                  Guardar
                </button>
                <button
                  class="btn-secundario"
                  type="button"
                  @click="editar('aduanero_exportacion', 'transporte')"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!--FECHA SALIDA PROGRAMADA -->
      <div
        v-if="
          despacho.tipo.fecha_ingreso_zona_primaria &&
          estados.fecha_ingreso_zona_primaria
        "
      >
        <div class="text-left">
          <p>Fecha Ingreso Zona Primaria</p>
        </div>
        <div class="text-right">
          {{
            despacho?.tipo?.fecha_ingreso_zona_primaria
              ? moment(despacho.tipo.fecha_ingreso_zona_primaria).format(
                  "DD-MM-YYYY"
                )
              : "-"
          }}
        </div>
        <div class="text-right">
          <button
            v-if="pantalla == true"
            @click="
              editar('aduanero_exportacion', 'fecha_ingreso_zona_primaria')
            "
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="
              editar('aduanero_exportacion', 'fecha_ingreso_zona_primaria')
            "
            class="btn-principal"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else>
        <div class="text-right">
          <form class="form-input">
            <div>
              <div>
                <b-form-group
                  class="text-left"
                  label="Fecha Ingreso Zona Primaria"
                  label-for="importancia-select"
                >
                  <input
                    type="date"
                    v-model="fecha_ingreso_zona_primaria"
                    required
                  />
                </b-form-group>
              </div>

              <div>
                <button
                  class="btn-principal"
                  type="button"
                  @click="
                    editar(
                      'aduanero_exportacion',
                      'fecha_ingreso_zona_primaria',
                      true,
                      {
                        fecha_ingreso_zona_primaria:
                          fecha_ingreso_zona_primaria,
                      }
                    )
                  "
                >
                  Guardar
                </button>
                <button
                  class="btn-secundario"
                  type="button"
                  @click="
                    editar(
                      'aduanero_exportacion',
                      'fecha_ingreso_zona_primaria'
                    )
                  "
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!--FECHA SALIDA PROGRAMADA -->
      <div
        v-if="
          despacho.tipo.fecha_salida_programada &&
          estados.fecha_salida_programada
        "
      >
        <div class="text-left">
          <p>Fecha Salida Programada</p>
        </div>
        <div class="text-right">
          {{
            despacho?.tipo?.fecha_salida_programada
              ? moment(despacho.tipo.fecha_salida_programada).format(
                  "DD-MM-YYYY"
                )
              : "-"
          }}
        </div>
        <div class="text-right">
          <button
            v-if="pantalla == true"
            @click="editar('aduanero_exportacion', 'fecha_salida_programada')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('aduanero_exportacion', 'fecha_salida_programada')"
            class="btn-principal"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else>
        <div class="text-right">
          <form class="form-input">
            <div>
              <div sm="12" md="12" lg="6">
                <b-form-group
                  class="text-left"
                  label="Fecha Salida Programada"
                  label-for="importancia-select"
                >
                  <input
                    type="date"
                    v-model="fecha_salida_programada"
                    required
                  />
                </b-form-group>
              </div>

              <div>
                <button
                  class="btn-principal"
                  type="button"
                  @click="
                    editar(
                      'aduanero_exportacion',
                      'fecha_salida_programada',
                      true,
                      { fecha_salida_programada: fecha_salida_programada }
                    )
                  "
                >
                  Guardar
                </button>
                <button
                  class="btn-secundario"
                  type="button"
                  @click="
                    editar('aduanero_exportacion', 'fecha_salida_programada')
                  "
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <form-group-select
        label="Estado"
        v-model="despacho.tipo.estado"
        :options="informacionGeneral?.estado_salida"
        @save="editar('aduanero_exportacion', 'estado')"
        @cancel="editar('aduanero_exportacion', 'estado')"
        required
      />

      <form-group-select
        label="Estado Salida"
        v-model="despacho.tipo.estado_salida"
        :options="informacionGeneral?.estado_salida"
        @save="editar('aduanero_exportacion', 'estado_salida')"
        @cancel="editar('aduanero_exportacion', 'estado_salida')"
        required
      />

      <form-group-select
        label="Aforo Zona Primaria"
        v-model="aforo_zona_primaria"
        :options="informacionGeneral.aforo_zona_primaria"
        @save="
          editar('aduanero_exportacion', 'aforo_zona_primaria', true, {
            aforo_zona_primaria: aforo_zona_primaria,
          })
        "
        @cancel="editar('aduanero_exportacion', 'aforo_zona_primaria')"
        required
      />

      <!--ESTADO FECHA AFORO ZONA PRIMARIA -->
      <div
        v-if="
          despacho.tipo.fecha_aforo_zona_primaria &&
          estados.fecha_aforo_zona_primaria
        "
      >
        <div class="text-left">
          <p>Fecha Aforo Zona Primaria</p>
        </div>
        <div class="text-right">
          {{
            despacho.tipo.fecha_aforo_zona_primaria
              ? moment(despacho.tipo.fecha_aforo_zona_primaria).format(
                  "DD-MM-YYYY"
                )
              : "-"
          }}
        </div>
        <div class="text-right">
          <button
            v-if="pantalla == true"
            @click="editar('aduanero_exportacion', 'fecha_aforo_zona_primaria')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('aduanero_exportacion', 'fecha_aforo_zona_primaria')"
            class="btn-principal"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else>
        <div class="text-right">
          <form class="form-input">
            <div>
              <div>
                <b-form-group
                  class="text-left"
                  label="Fecha Aforo Zona Primaria"
                  label-for="importancia-select"
                >
                  <input
                    type="date"
                    v-model="fecha_aforo_zona_primaria"
                    required
                  />
                </b-form-group>
              </div>
              <div>
                <button
                  class="btn-principal"
                  type="button"
                  @click="
                    editar(
                      'aduanero_exportacion',
                      'fecha_aforo_zona_primaria',
                      true,
                      { fecha_aforo_zona_primaria: fecha_aforo_zona_primaria }
                    )
                  "
                >
                  Guardar
                </button>
                <button
                  class="btn-secundario"
                  type="button"
                  @click="
                    editar('aduanero_exportacion', 'fecha_aforo_zona_primaria')
                  "
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!--ESTADO AFORO ZONA DUS LEGALIZADA -->
      <form-group-select
        label="Aforo Dus Legalizado"
        v-model="aforo_dus_legalizado"
        :options="informacionGeneral.aforo_dus_legalizado"
        @save="
          editar('aduanero_exportacion', 'aforo_dus_legalizado', true, {
            aforo_dus_legalizado: aforo_dus_legalizado,
          })
        "
        @cancel="editar('aduanero_exportacion', 'aforo_dus_legalizado')"
        required
      />


      <!--ESTADO FECHA AFORO ZONA PRIMARIA -->
      <div
        v-if="
          despacho.tipo.fecha_aforo_dus_legalizado &&
          estados.fecha_aforo_dus_legalizado
        "
      >
        <div class="text-left">
          <p>Fecha Aforo Dus Legalizado</p>
        </div>
        <div class="text-right">
          {{
            despacho?.tipo?.fecha_aforo_dus_legalizado
              ? moment(despacho.tipo.fecha_aforo_dus_legalizado).format(
                  "DD-MM-YYYY"
                )
              : "-"
          }}
        </div>
        <div class="text-right">
          <button
            v-if="pantalla == true"
            @click="
              editar('aduanero_exportacion', 'fecha_aforo_dus_legalizado')
            "
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="
              editar('aduanero_exportacion', 'fecha_aforo_dus_legalizado')
            "
            class="btn-principal"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else>
        <div class="text-right">
          <form class="form-input">
            <div>
              <div>
                <b-form-group
                  class="text-left"
                  label="Fecha Aforo Dus Legalizado"
                  label-for="importancia-select"
                >
                  <input
                    type="date"
                    v-model="fecha_aforo_dus_legalizado"
                    required
                  />
                </b-form-group>
              </div>
              <div>
                <button
                  class="btn-principal"
                  type="button"
                  @click="
                    editar(
                      'aduanero_exportacion',
                      'fecha_aforo_dus_legalizado',
                      true,
                      { fecha_aforo_dus_legalizado: fecha_aforo_dus_legalizado }
                    )
                  "
                >
                  Guardar
                </button>
                <button
                  class="btn-secundario"
                  type="button"
                  @click="
                    editar('aduanero_exportacion', 'fecha_aforo_dus_legalizado')
                  "
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
